const AspspAlert = () => null;

export default AspspAlert;
